(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mappa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function avvia(radice) {
      var src = radice.dataset.src;
      if (!src) return;

      var slot = radice.querySelector('.pr-mappa__slot');
      var avviso = radice.querySelector('[data-mappa-avviso]');
      var preferenze = radice.querySelector('[data-mappa-preferenze]');

      function carica() {
        if (slot.querySelector('iframe')) return;
        var frame = document.createElement('iframe');
        frame.src = src;
        frame.loading = 'lazy';
        frame.title = radice.dataset.titolo || '';
        frame.setAttribute('allowfullscreen', '');
        slot.appendChild(frame);
        if (avviso) avviso.hidden = true;
      }

      function rifiuta() {
        if (!avviso) return;
        avviso.hidden = false;
        // Il link alle preferenze compare solo se il banner espone davvero il
        // metodo per riaprirle: altrimenti sarebbe un pulsante che non fa nulla.
        if (preferenze && window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          preferenze.hidden = false;
        }
      }

      // null = non lo sappiamo ancora, e nel dubbio non si carica niente.
      function consentito() {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp) return null;
        try {
          return cp.preferencesProcessingAllowed() || cp.analyticsProcessingAllowed();
        } catch (e) {
          return null;
        }
      }

      function valuta() {
        var esito = consentito();
        if (esito === true) carica();
        else rifiuta();
      }

      document.addEventListener('visitorConsentCollected', valuta);

      if (preferenze) {
        preferenze.addEventListener('click', function () {
          window.privacyBanner.showPreferences();
        });
      }

      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          valuta();
        });
      } else {
        valuta();
      }
    }

    document.querySelectorAll('[data-mappa]').forEach(avvia);
  })();

  } catch(e) { console.error(e); }
})();
})();
